export default "__VITE_ASSET__DbyGZony__"